import {
	PostHandler,
	QueryHandler
} from "../event-driven/core-utils/core-decorators";
import AxiosAPIInterface from "./axios-api-interface";

export const CUSTOM_FIELDS_API = {
	ADD_FIELD: "ADD_FIELD",
	UPDATE_FIELD: "UPDATE_FIELD",
	DELETE_FIELD: "DELETE_FIELD",
	GET_FIELDS_LIST: "GET_FIELDS_LIST",
	UPDATE_FIELD_ORDER: "UPDATE_FIELD_ORDER",
	GET_CUSTOM_FIELDS: "GET_CUSTOM_FIELDS",
	CUSTOM_FIELD_ENTITY_MAPPING: "CUSTOM_FIELD_ENTITY_MAPPING",
	ENTITY_UPDATE: "ENTITY_UPDATE",
	CREATE_NEW_ENTITY: "CREATE_NEW_ENTITY"
};
export default class CustomFieldsAPI extends AxiosAPIInterface {
	constructor() {
		if (CustomFieldsAPI._instance) {
			return CustomFieldsAPI._instance;
		}
		super({ resoucePath: "/fields" });
		CustomFieldsAPI._instance = this;
	}

	@QueryHandler(CUSTOM_FIELDS_API.GET_CUSTOM_FIELDS)
	getCustomFields({ params }) {
		return this.get({ path: `/assignment`, params });
	}

	@PostHandler(CUSTOM_FIELDS_API.ADD_FIELD)
	addField({ payload, params }) {
		return this.post({ path: "/", body: payload, params: params });
	}

	@PostHandler(CUSTOM_FIELDS_API.UPDATE_FIELD)
	updateField({ payload, id }) {
		return this.put({ path: `/${id}`, body: payload });
	}

	@QueryHandler(CUSTOM_FIELDS_API.GET_FIELDS_LIST)
	getCustomFieldList({ params }) {
		return this.get({ path: `/`, params });
	}

	@QueryHandler(CUSTOM_FIELDS_API.DELETE_FIELD)
	deleteCustomField({ id, params }) {
		return this.delete({ path: `/${id}`, params });
	}

	@PostHandler(CUSTOM_FIELDS_API.UPDATE_FIELD_ORDER)
	updateFieldOrder({ payload }) {
		return this.put({ path: `/order`, body: payload });
	}

	@QueryHandler(CUSTOM_FIELDS_API.CUSTOM_FIELD_ENTITY_MAPPING)
	getEntityMapping({ params }) {
		return this.get({ path: "/entity-mapping", params });
	}

	@PostHandler(CUSTOM_FIELDS_API.ENTITY_UPDATE)
	updateEntityMapping({ payload }) {
		return this.put({ path: `/assignment`, body: payload });
	}

	@PostHandler(CUSTOM_FIELDS_API.CREATE_NEW_ENTITY)
	createNewEntityMapping({ payload }) {
		return this.post({ path: `/assignment`, body: payload });
	}
}
